import { render, staticRenderFns } from "./GreenLocationForm.vue?vue&type=template&id=583f197c&scoped=true&"
import script from "./GreenLocationForm.vue?vue&type=script&lang=js&"
export * from "./GreenLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583f197c",
  null
  
)

export default component.exports